/* eslint-disable @typescript-eslint/no-empty-function */
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

export type EmptyStateType =
  | 'documents'
  | 'distributor'
  | 'empty-clipboard'
  | 'empty-team'
  | 'no-link'
  | 'policy-documents'
  | 'blank-documents';

export interface EmptyStateConfig {
  title?: string;
  subtitle?: string;

  imgsrc?: EmptyStateType;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-empty-state',
  templateUrl: 'empty-state.component.html',
  standalone: false,
})
export class EmptyStateComponent {
  @HostBinding('class') get styles(): string {
    return 'w-full';
  }

  @Input() config: EmptyStateConfig = {};
}
